<template>
  <v-container>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        v-show="showDialog"
        @click:outside="closeDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-form ref="form" lazy-validation @input="formToggled">
            <v-card-title class="subtitle-1 grey accent" primary-title>
              <span v-if="!isUpdate" class="text-h5">Add WholeSale Brands</span>
              <span v-if="isUpdate" class="text-h5">Update WholeSale Brands</span>

            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-text-field
                      color="accent"
                      label="Name"
                      v-model="currentBrand.name"
                      type="text"
                      outlined
                      dense
                      clearable
                      :rules="[rules.required]"
                      @wheel="$event.target.blur()"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      color="accent"
                      label="SKU code"
                      v-model="currentBrand.SKU_Code"
                      type="text"
                      outlined
                      dense
                      clearable
                      :rules="[rules.required]"
                      @wheel="$event.target.blur()"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialog">
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                v-if="!isUpdate"
                text
                @click="CreateBrand"
              >
                Save
              </v-btn>
              <v-btn
                color="blue darken-1"
                v-if="isUpdate"
                text
                @click="CreateBrand"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
        @showProductInfo="postSearch(product.SKU)"
        :textColor="textColor"
        :showCheckBtn="showCheckBtn"
      ></status-info>
    </v-dialog>
    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo";

export default {
  name: "create-wh-brand",
  props: {
    Brand: Object,
    close: Function,
    isUpdate: Boolean,
    DoesCreated: Function,
  },
  components: {
    StatusInfo,
  },
  data: () => ({
    dialog: true,
    showDialog: true,
    statusDialog: false,
    pending: false,
    filename: "",
    showCheckBtn: false,
    textColor: "",
    responseMessage: "",
    currentBrand: {},
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    snackbarText: "",
    snackbar: false,
    ForUpdate: false,
  }),
  mounted() {
    console.log(this.isUpdate)
    console.log(this.Brand)
    this.ForUpdate = this.isUpdate;
    if (this.isUpdate) {
      this.currentBrand = this.Brand;
    }
  },

  methods: {
    closeDialog() {
      this.close();
      this.dialog = false;
    },
    closeStatusDialog() {
      this.close();
      this.dialog = false;
      this.statusDialog = false;
      this.showDialog = false;
    },
    formToggled() {},
    async CreateBrand() {
      if (this.$refs.form.validate()) {
        //show pending dialog
        this.pending = true;
        this.statusDialog = true;
        this.textColor = "basic--text";
        //stop showing product form dialog
        this.dialog = false;
        // TODO create the function that will call the API !
        if (!this.isUpdate ) {
          this.$store
          .dispatch("createBrand", this.currentBrand)
          .then(() => {
            this.pending = false;
            this.statusDialog = true;
            this.responseMessage = "Brand created ! ";
            this.filename = "high_five.svg";
            this.DoesCreated()
          })
          .catch((error) => {
            console.log(error);
            this.pending = false;
            this.statusDialog = true;
            this.filename = "server_down.svg";
            this.responseMessage = "Something went wrong! Please try again!";
          });
        }else {
          this.$store
          .dispatch("updateWHBrand", this.currentBrand)
          .then(() => {
            this.pending = false;
            this.statusDialog = true;
            this.responseMessage = "Brand Updated ! ";
            this.filename = "high_five.svg";
            this.DoesCreated()
          })
          .catch((error) => {
            console.log(error);
            this.pending = false;
            this.statusDialog = true;
            this.filename = "server_down.svg";
            this.responseMessage = "Something went wrong! Please try again!";
          });
        }
  
      } else {
        this.snackbarText = "The form is filled incorretly!";
        this.snackbar = true;
      }
    },
  },
};
</script>

<style>
.add_wh_pr_modal {
  background-color: #fff !important;
}
div#text {
  margin-top: 48px;
  text-align: center;
}
div#dropzone {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: visibility 175ms, opacity 175ms;
  display: table;
  text-shadow: 1px 1px 2px #000;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  font: bold 42px Oswald, DejaVu Sans, Tahoma, sans-serif;
}
div#textnode {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  transition: font-size 175ms;
}
</style>
